<template>
  <v-card flat height="100vh" class="body__background-color">
    <v-col align="center">
      <div class="mb-10">{{ $translate('NO_SHOPLIST_YET') }}</div>

      <template v-if="showSubscibeBtn">
        <v-btn
          class="mb-4 text-capitalize primary-font-color"
          color="primary"
          @click="onTakeSubscription"
        >
          {{ $translate('TAKE_SUBSCRIPTION') }}
        </v-btn>

        <v-row justify="center" align="center" class="ma-0 mb-4">
          <v-divider class="ml-8"></v-divider>
          <span class="px-4 text--secondary">{{ $translate('OR') }}</span>
          <v-divider class="mr-8"></v-divider>
        </v-row>
      </template>

      <v-btn
        class="text-capitalize primary-font-color"
        color="primary"
        @click="onCreateList"
      >
        {{ $translate('NEW_SHOPPING_LIST_TITLE') }}
      </v-btn>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: 'ShoppingListsNoData',
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    showSubscibeBtn() {
      if (
        this.partnerGroupDetails != null &&
        this.partnerGroupDetails.ShowSubscriptionButton
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onTakeSubscription() {
      this.$emit('take-subscription');
    },
    onCreateList() {
      this.$emit('create-list');
    },
  },
};
</script>
